<script setup>
import {onMounted, onUnmounted, reactive, ref} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  payPeriodId: Number
});

const data = reactive({
  holdbacksAlreadyReleased: [],
  holdbacksToBeReleased: [],
  alreadyDataLoading: false,
  toBeDataLoading: false,
  submitLoading: false,
  releasedHoldbacks: 0,
  success: false
});

const getAlreadyReleasedData = (()=>{
  data.alreadyDataLoading=true;
  ApiWrapper
      .get('holdbacks', 'get-already-released-holdbacks-for-pay-period', 'payPeriodId='+props.payPeriodId)
      .then((response) => {
          data.holdbacksAlreadyReleased = response.holdbacks;
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(()=>{
        data.alreadyDataLoading = false;
      });
});

const getHoldbackData = (()=>{
  data.toBeDataLoading=true;
  ApiWrapper
      .get('holdbacks', 'get-all-unreleased-holdbacks-for-pay-period', 'payPeriodId='+props.payPeriodId)
      .then((response) => {
          data.holdbacksToBeReleased = response.holdbacks;
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(()=>{
        data.toBeDataLoading = false;
      });
});

const releaseHoldbacks = (()=>{
  data.submitLoading = true;
  ApiWrapper
      .post('holdbacks', 'release-holdbacks-for-pay-period', {payPeriodId: props.payPeriodId})
      .then((response) => {
        if(response.releasedHoldbacks){
          data.releasedHoldbacks = response.releasedHoldbacks
        }
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(()=>{
        if(data.releasedHoldbacks>0){
          ToastUtil.successMsg(`Holdbacks released!`);
          data.success = true;
          getAlreadyReleasedData();
          getHoldbackData();
        }
        else{
          ToastUtil.errorMsg('No holdbacks were released. Please check the holdback data for this pay period.');
        }
        data.submitLoading = false;
      });
})

onMounted(()=>{
  getAlreadyReleasedData();
  getHoldbackData();
})

</script>

<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Release Holdbacks for Pay Period {{props.payPeriodId}}</v-card-title>
      <v-card-item>
        <v-card>
          <v-card-subtitle>Already Released: {{data.holdbacksAlreadyReleased.length}}</v-card-subtitle>
          <v-card-item>
            <v-data-table
                :items="data.holdbacksAlreadyReleased"
                :loading="data.alreadyDataLoading"
                loading-text="Loading... Please wait"
            >

            </v-data-table>
          </v-card-item>
          <v-card-subtitle>To Be Released: {{data.holdbacksToBeReleased.length}}</v-card-subtitle>
          <v-card-item>
            <v-data-table
                :items="data.holdbacksToBeReleased"
                :loading="data.toBeDataLoading"
                loading-text="Loading... Please wait"
            >
            </v-data-table>
          </v-card-item>
          <v-card-item v-if="!data.success && data.holdbacksToBeReleased.length>0">
            <v-btn
                color="primary"
                block
                class="mt-5 mb-5"
                variant="elevated"
                :loading="data.submitLoading"
                :disabled="data.holdbacksToBeReleased.length === 0"
                @click="releaseHoldbacks"
            >
              Release Holdbacks
            </v-btn>
          </v-card-item>
        </v-card>
        <v-card v-if="data.success">
          <v-card-title>
            Holdbacks Successfully Released!
          </v-card-title>
          <v-card-subtitle>
            <RouterLink :to="'/payperiod/'+props.payPeriodId">
              <v-btn
                  color="primary"
                  variant="elevated"
                  class="mt-3 mb-3"
              >
                Return to Pay Period View
              </v-btn>
            </RouterLink>
          </v-card-subtitle>
        </v-card>
      </v-card-item>
    </v-card>

  </v-container>
</template>

<style scoped>

</style>